import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {InlineLinkButton} from '../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface RuleEditorSidebarLearnMoreProps {
  onClick: Handler;
}

/*
 * Styles.
 */

const StyledContentDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-left: 6px;
`;

/*
 * Component.
 */

export const RuleEditorSidebarLearnMore: React.FC<RuleEditorSidebarLearnMoreProps> = (props) => {
  const {onClick} = props;

  return (
    <InlineLinkButton onClick={onClick}>
      <StyledContentDiv>
        <Trans id="rules-sidebar-learn-more">Learn more</Trans>
        <StyledIcon name="externalLinkSmall" />
      </StyledContentDiv>
    </InlineLinkButton>
  );
};
